<div class="table-page fraud-analysis" dir="rtl">
  <div class="fraud-analysis-toolbar" [formGroup]="dateForm">
    <h2>وضعیت تحلیل</h2>
    <div class="actions">
      <label for="fraud-analysis-date">تاریخ تحلیل</label>
      <ng-persian-datepicker class="fraud-datepicker" [uiTheme]="'gray'" [timeEnable]="false"
        [dateInitValue]="false" [dateFormat]="'jYYYY/jMM/jDD'" [dateGregorianFormat]="'YYYY/MM/DD'"
        [uiHideAfterSelectDate]="true" [uiHideOnOutsideClick]="true">
        <input id="fraud-analysis-date" class="control" type="text" dir="ltr" readonly formControlName="date" />
      </ng-persian-datepicker>
      <button class="btn btn-primary" type="button" [disabled]="loading" (click)="loadAnalysis()">
        <i class="fa fa-refresh" aria-hidden="true"></i> بروزرسانی
      </button>
    </div>
  </div>

  <section class="card" [attr.aria-busy]="loading">
    <div class="fraud-panel-heading"><h2>وضعیت پردازش بازه‌های روزانه</h2></div>
    <div class="body">
      <div *ngIf="loading" class="loader show">
        <div class="spinner"></div>
        <span>در حال دریافت وضعیت تحلیل...</span>
      </div>
      <div *ngIf="!loading && error" class="state show error">
        <i class="fa fa-exclamation-triangle ico-big" aria-hidden="true"></i>
        <p>{{ error }}</p>
        <button class="btn btn-ghost" type="button" (click)="loadAnalysis()">تلاش دوباره</button>
      </div>
      <div *ngIf="!loading && !error && !analysis" class="state show">
        <i class="fa fa-clock-o ico-big" aria-hidden="true"></i>
        <h3>اطلاعاتی برای این روز ثبت نشده است.</h3>
        <p>برای دریافت وضعیت تحلیل، دوباره تلاش کنید.</p>
        <button class="btn btn-ghost" type="button" (click)="loadAnalysis()">تلاش دوباره</button>
      </div>

      <div *ngIf="!loading && !error && analysis" class="fraud-panel-content">
        <div class="fraud-analysis-cards">
          <div class="fraud-stat fraud-stat-green">
            <div class="fraud-stat-label">بازه‌های تکمیل‌شده</div>
            <div class="fraud-stat-value">{{ analysis.iCompletedWindows | number | faNum }}</div>
            <div class="fraud-stat-note">وضعیت {{ 2 | faNum }}</div>
          </div>
          <div class="fraud-stat fraud-stat-blue">
            <div class="fraud-stat-label">در حال اجرا</div>
            <div class="fraud-stat-value">{{ analysis.iRunningWindows | number | faNum }}</div>
            <div class="fraud-stat-note">وضعیت {{ 1 | faNum }}</div>
          </div>
          <div class="fraud-stat fraud-stat-orange">
            <div class="fraud-stat-label">در انتظار</div>
            <div class="fraud-stat-value">{{ analysis.iPendingWindows | number | faNum }}</div>
            <div class="fraud-stat-note">وضعیت {{ 0 | faNum }}</div>
          </div>
          <div class="fraud-stat fraud-stat-red">
            <div class="fraud-stat-label">دارای خطا</div>
            <div class="fraud-stat-value">{{ analysis.iFailedWindows | number | faNum }}</div>
            <div class="fraud-stat-note">وضعیت {{ 3 | faNum }}</div>
          </div>
        </div>

        <div class="fraud-analysis-progress">
          <div class="fraud-analysis-caption">
            <strong>{{ progress | faNum }}٪ تکمیل</strong>
            <span class="muted">{{ analysis.iCompletedWindows | number | faNum }} از {{ analysis.iTotalWindows | number | faNum }} بازه</span>
          </div>
          <progress class="fraud-progress" [value]="progress" max="100" aria-label="درصد تکمیل تحلیل روز"></progress>
          <div class="fraud-analysis-counts muted">
            <span>در حال اجرا: {{ analysis.iRunningWindows | number | faNum }}</span>
            <span>خطادار: {{ analysis.iFailedWindows | number | faNum }}</span>
          </div>
        </div>
        <p class="fraud-analysis-note muted">هر روز در حالت معمول {{ 144 | faNum }} بازهٔ {{ 10 | faNum }} دقیقه‌ای دارد.</p>
      </div>
    </div>
  </section>
</div>
